import { buildConventionalCrudAPI, callDelete, get } from "@/services/api.services";
import {
    ExperimentSetupRelationshipConfig,
    ManageExperimentSetupRelationshipConfigDTO,
    RelationshipConfigForExperimentSetup,
    RelationshipConfigsForType,
    SavedExperimentSetupRelationshipConfig,
} from "@/services/experimentRelationships/models";

export function buildExperimentConfigRelationshipAPIForSchemaConfig(schemaConfigId: string) {
    const basePath = `/experimentRelationshipConfigs/schemaConfig/${schemaConfigId}`;
    const baseAPI = buildConventionalCrudAPI<
        ExperimentSetupRelationshipConfig,
        SavedExperimentSetupRelationshipConfig
    >(basePath);

    async function fetchAllDTOs(): Promise<
        RelationshipConfigsForType<ManageExperimentSetupRelationshipConfigDTO>[]
    > {
        return get(`${basePath}`);
    }

    return {
        ...baseAPI,
        fetchAllDTOs,
    };
}

export function buildExperimentConfigRelationshipAPIForExperimentGroup(experimentGroupId: string) {
    const basePath = `/experimentRelationshipConfigs/experimentGroup/${experimentGroupId}`;
    const baseAPI = buildConventionalCrudAPI<
        ExperimentSetupRelationshipConfig,
        SavedExperimentSetupRelationshipConfig
    >(basePath);

    /**
     Fetch all RelationshipConfig DTOs for the given experiment group, including those inherited
     from the associated schema config
     */
    async function fetchAllDTOs(): Promise<
        RelationshipConfigsForType<ManageExperimentSetupRelationshipConfigDTO>[]
    > {
        return get(`${basePath}`);
    }

    return {
        ...baseAPI,
        fetchAllDTOs,
    };
}

export const baseRelationshipConfigAPI = {
    deleteRelationshipConfig: async (id: string) => {
        await callDelete("/experimentRelationshipConfigs/" + id);
    },
};

export const experimentRelationshipConfigAPIForSetup = {
    fetchRelationshipConfigsForExperimentSetup(
        experimentGroupId: string
    ): Promise<RelationshipConfigsForType<RelationshipConfigForExperimentSetup>[]> {
        return get(`/experimentRelationshipConfigs/experimentSetup/${experimentGroupId}`);
    },
};
